export const twentyFourToTwelve = time => {
  let arr = time.split(":");

  let hour = parseInt(arr[0]);
  let ampm = hour > 11 ? "PM" : "AM";

  let minutes = arr[1];
  return `${hour % 12}:${minutes} ${ampm}`;
};
